<template>
  <div>
    <HeaderGestion/>
    <SubHeader
      nombre="Utilidades para miembros SVE"
      precedente="Hola"
      color= "2"
    />
    <FormUtilidadesSVE/>
  </div>
</template>

<script>
import HeaderGestion from '../components/HeaderGestion.vue'
import SubHeader from '../components/SubHeader.vue'
import FormUtilidadesSVE from '../components/FormUtilidadesSVE.vue'
export default {
  components: { HeaderGestion, SubHeader, FormUtilidadesSVE },
  name: 'UtilidadesSVE'
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
</style>
